/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Nav_AbilitiesInputs */

const en_control_nav_abilities = /** @type {(inputs: Control_Nav_AbilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilities`)
};

const zh_control_nav_abilities = /** @type {(inputs: Control_Nav_AbilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能力选择`)
};

/**
* | output |
* | --- |
* | "Abilities" |
*
* @param {Control_Nav_AbilitiesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_nav_abilities = /** @type {((inputs?: Control_Nav_AbilitiesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Nav_AbilitiesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_nav_abilities(inputs)
	return zh_control_nav_abilities(inputs)
});
export { control_nav_abilities as "control.nav.abilities" }